import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import { styled } from '@mui/system';
import { navigate } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import Shop from '../shop';
import { ShopContext } from './ShopProvider';
import { TypeOcr } from './Types';
/*export default function ButtonCheckout() {
  const url = shop.getCheckoutUrl();

  const [count, setCount] = React.useState(shop.getLineItemCount());

  shop.addCallback(() => {
    console.log("callback", shop.getLineItemCount());
    setCount(shop.getLineItemCount());
  });

  return (
    <>
      <Button
        color="info"
        variant="outlined"
        style={{
          borderRadius: "0px",
          alignItems: "center",
          justifyContent: "center",
          whiteSpace: "normal",
          wordBreak: "break-all",
          display: "flex",
          fontFamily: "OCR A Std",
          fontSize: "1rem",
        }}
        sx={{ mr: 2 }}
      >
        <Link color="inherit" underline="none" href={url}>
          <>Checkout ({count})</>
        </Link>
      </Button>
    </>
  );
}
*/

const images = [
  {
    url: '../feetbat.png',
    title: 'cart',
    width: '100%',
  },
];

const ImageButton = styled(ButtonBase)(({ theme }) => ({
  position: 'relative',
  height: 68,
  [theme.breakpoints.down('sm')]: {
    width: '100% !important', // Overrides inline-style
  },
  '&:hover, &.Mui-focusVisible': {
    '& .MuiImageBackdrop-root': {
      opacity: 0.3,
    },
    '& .MuiImageMarked-root': {
      opacity: 0,
    },
  },
}));

//actual image
const ImageSrc = styled('span')({
  position: 'absolute',
  top: 0,
  bottom: 0,
  backgroundSize: '90px',
  backgroundPosition: 'top',
  backgroundRepeat: 'no-repeat',
});

//wraps text to place on top of image
const Bat = styled('span')(({ theme }) => ({
  position: 'absolute',
  top: 0,

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.common.white,
}));

//sets fade on hover
const ImageBackdrop = styled('span')(({ theme }) => ({
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  backgroundColor: theme.palette.common.white,
  opacity: 0,
  //transition: theme.transitions.create('opacity'),
}));

export default function ButtonCheckout() {
  const shop = React.useContext(ShopContext) as Shop;
  const count = shop.getLineItemCount();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'start',
        justifyContent: 'right',
      }}
    >
      <Box sx={{ display: 'flex', minWidth: 100, width: '100%', height: 65 }}>
        <ImageButton
          focusRipple
          style={{
            width: '100%',
          }}
          onClick={() => {
            navigate('/pages/cart');
          }}
        >
          <StaticImage
            alt='feetbat'
            src='./feetbat.png'
            height={65}
            layout='constrained'
            loading='eager'
          />
          <ImageBackdrop className='MuiImageBackdrop-root' />
          <Bat>
            <TypeOcr
              component='span'
              variant='subtitle1'
              color='inherit'
              sx={{
                position: 'relative',
                p: 4,
                pt: 2.8,
                pb: (theme) => `calc(${theme.spacing(1)} + 6px)`,
              }}
            >
              <>{count}</>
            </TypeOcr>
          </Bat>
        </ImageButton>
      </Box>
    </Box>
  );
}

//<Link color="inherit" underline="none" href={url}>
//to make it bat logo again
/*{images.map((image) => (
          <ImageButton
            focusRipple
            key={image.url}
            style={{
              width: image.width,
            }}
          >
            <ImageSrc style={{ backgroundImage: `url(${image.url})` }} sx={{ width: "100%", fit: "scale-down" }} />
            <ImageBackdrop className="MuiImageBackdrop-root" />
            <Image>
              <TypeOcr
                component="span"
                variant="subtitle1"
                color="inherit"
                sx={{
                  position: 'relative',
                  p: 4,
                  pt: 2,
                  pb: (theme) => `calc(${theme.spacing(1)} + 6px)`,
                }}
              >

                <>{count}</>

              </TypeOcr>
            </Image>
          </ImageButton>
        ))}*/
